import { useEffect, useState } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import PCH_USER from '../graphql/PCH_USER';
import ADD_USER_PCH from '../graphql/ADD_USER_PCH';

const usePchLookup = (pt1, pt2, hsid, emailParam) => {
	const [ pchUser, setPchUser ] = useState(null);
	const [ addUserPCH ] = useMutation(ADD_USER_PCH, {
        onCompleted: (data) => console.log(data.addUserPCH.message)
    });

	const handleCompletion = (data) => {
		if(data.fetchUserInfo.success) {
			console.log(data.fetchUserInfo.message);
			const userRes = data.fetchUserInfo.body;
			const userData = {
				title: userRes['Title'],
				EMAIL: userRes['EmailAddress'],
				fname: userRes['FirstName'],
				lname: userRes['LastName'],
				address: userRes['Address1'],
				city: userRes['City'],
				state: userRes['State'],
				zip: userRes['ZipCode'],
				successful: true
			};
			setPchUser(userData);
		} else {
			setPchUser({
				title: '',
				EMAIL: emailParam || '',
				fname: '',
				lname: '',
				address: '',
				city: '',
				state: '',
				zip: '',
				successful: false
			});
		}
	};

	useQuery(PCH_USER, {
		skip: !pt1 || !pt2 || !!pchUser || !hsid,	
		variables: { pat: pt1, gmt: pt2 },
		onCompleted: handleCompletion,
		onError: (err) => console.log('Error occurred during pch lookup!', err)
	});

	useEffect(() => {
		if(!hsid || hsid === 0) return;
		if((!pt1 && !pchUser) || (!pt2 && !pchUser)) {
			setPchUser({
				title: '',
				EMAIL: emailParam || '',
				fname: '',
				lname: '',
				address: '',
				city: '',
				state: '',
				zip: '',
				successful: false
			});
		};
		// eslint-disable-next-line
	},[pt1, pt2, hsid]);

	useEffect(() => {
		if(pchUser?.successful) {
			addUserPCH({
				variables: {
					clickId: Number(hsid),
					pch: {
						gmt: pt2,
						title: pchUser['title'],
						firstname: pchUser['fname'] || '',
						lastname: pchUser['lname'],
						address: pchUser['address'],
						city: pchUser['city'],
						state: pchUser['state'],
						zipcode: pchUser['zip']
					}
				}
			});
		};
		// eslint-disable-next-line
	},[pchUser]);

	return pchUser;
};

export default usePchLookup;